export type { Props as HtmlAnchorProps } from './html-anchor';
export { HtmlAnchor } from './html-anchor';
